module.exports = __webpack_public_path__ + "c6c77a7cad9eaf8e02428ca2d3bbf058.png";